import React, { Component } from 'react'
import './Terms.css'
import './TermsResponsive.css'

class Terms extends Component {
  render () {
    return (
      <div id='terms' className='terms'>
        <div className='tc'>Terms and Conditions</div>
        <div className='menu-blk'>
          <ul>
            {this.props.terms.map((item, index) => {
              return <li key={index}>{item}</li>
            })
            }
          </ul>
        </div>
      </div>
    )
  }
}
export default Terms
